import React from "react";

const AIDisruptionRajan = () => {
  return (
    <div style={{ background: '#f8fafb', minHeight: '100vh', padding: '10px 16px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <article style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)' }}>
          <div style={{ background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', color: '#fff', padding: '14px 32px 12px 32px', textAlign: 'center' }}>
            <h1 style={{ margin: '0 0 8px 0', fontSize: '1.48rem', fontWeight: 500, lineHeight: 1.28, letterSpacing: '-0.4px' }}>
              AI Doomsday? Raghuram Rajan on India’s Services Sector
            </h1>
            <p style={{ margin: 0, fontSize: '0.95rem', opacity: 0.95, fontWeight: 400 }}>
              Disrupted, Not Derailed
            </p>
          </div>

          <div style={{ padding: '14px 32px 32px 32px', marginTop: '6px' }}>
            <p style={{ fontSize: '1.05rem', lineHeight: 1.5, color: '#333', marginBottom: '24px', fontWeight: 425, backgroundColor: '#f0f4ff', padding: '20px 24px', borderRadius: '8px', borderLeft: '4px solid #1976d2' }}>
              Artificial Intelligence may be transforming industries worldwide, but fears of a complete collapse of India’s services sector are overblown,
              says former RBI Governor <strong>Raghuram Rajan</strong>. He frames AI not as an existential threat, but as a challenge that requires
              adaptation, reskilling, and policy support.
            </p>

            <blockquote style={{ borderLeft: '4px solid #1976d2', padding: '10px 16px', color: '#444', fontStyle: 'italic', background: '#f8fbff', borderRadius: '0 6px 6px 0', marginBottom: '24px' }}>
              “The Indian services story can still persist in many other areas outside of software, but yes, AI will be a challenge.
              Things take time. Firms that are not technology-savvy will take more time. That is it.”
            </blockquote>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '34px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>AI: Disruption Is Real</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '16px' }}>
              India’s IT and services sector — a backbone of the country’s economic growth — is already feeling the impact of automation.
              Routine coding tasks, testing services, and customer support roles are increasingly vulnerable as companies deploy AI tools.
            </p>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px' }}>
              A recent research note flagged potential revenue pressure on Indian IT firms, triggering market volatility earlier in the week.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '34px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>But Not a Collapse</h2>
            <blockquote style={{ borderLeft: '4px solid #1976d2', padding: '10px 16px', color: '#444', fontStyle: 'italic', background: '#f8fbff', borderRadius: '0 6px 6px 0', marginBottom: '16px' }}>
              “Let’s not get overly wound up in science fiction and think that is the outcome.”
            </blockquote>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px' }}>
              Rajan emphasizes that while AI adoption may appear rapid among leading technology firms,
              widespread global implementation takes considerably longer.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '34px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>Reskilling Is the Key</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '14px' }}>
              According to Rajan, Indian software firms and professionals must rapidly retrain and move up the value chain.
            </p>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.25, color: '#555', marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>AI integration and automation services</li>
              <li style={{ marginBottom: '8px' }}>Higher-value engineering and digital consulting</li>
              <li style={{ marginBottom: '8px' }}>Research, innovation, and product development</li>
            </ul>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px' }}>
              “This is not something they cannot overcome,” he said.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '34px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>India’s Cost Advantage Remains Strong</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px' }}>
              Despite AI disruption, India retains a competitive edge — affordability combined with a highly skilled workforce.
              Consultants in India often cost significantly less than their Western counterparts, which could help firms stay globally
              competitive even as AI evolves.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '34px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>Beyond IT: Manufacturing and Policy</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px' }}>
              Rajan also highlights AI’s growing influence in manufacturing through robotics and automation.
              He suggests policymakers prioritize education, research, and skill development to strengthen long-term competitiveness.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '34px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>The Bottom Line</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px', backgroundColor: '#fff3e0', padding: '20px 24px', borderRadius: '8px', borderLeft: '4px solid #ff9800' }}>
              Artificial Intelligence will disrupt India’s services economy — particularly software and outsourcing — but it is unlikely to derail it.
              The speed of adaptation will determine whether India continues to thrive as a global services powerhouse in the AI era.
            </p>

            <div style={{ borderTop: '1px solid #e3f2fd', paddingTop: '20px', marginTop: '32px' }}>
              <p style={{ fontSize: '0.75rem', color: '#888', fontStyle: 'italic', margin: 0 }}>
                Article by <strong>Mangalorehub.com Current Affairs Desk</strong>
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default AIDisruptionRajan;